<template>
  <sprite
    :x="Math.floor(logoComponent.x)"
    :y="Math.floor(logoComponent.y)"
    :width="logoComponent.width"
    :height="logoComponent.height"
    src="logo.png"
  />
</template>

<script>
import { components, mixins } from '@/vame.js'

const { Sprite } = components
const { ecsContainer } = mixins

export default {
  mixins: [
    ecsContainer
  ],

  components: {
    Sprite
  },

  computed: {
    logoComponent () {
      const components = this.$store.state.components[this.entity.uid]
      return components.find((c) => c.kind === 'vue-logo')
    }
  }
}
</script>
